import { userModel } from '@_entities/user';

import { AppleIcon, GoogleIcon, KakaoIcon, NaverIcon } from '@_shared/icons';
import * as S from './SocialMessage.style';

interface Props {
	social: userModel.TUser['social'];
}

const socialList = {
	naver: {
		Icon: <NaverIcon />,
		name: '네이버',
	},
	kakao: {
		Icon: <KakaoIcon />,
		name: '카카오',
	},
	google: {
		Icon: <GoogleIcon />,
		name: '구글',
	},
	apple: {
		Icon: <AppleIcon />,
		name: '애플',
	},
};

export function SocialMessage({ social }: Props) {
	return (
		<>
			<S.IconWrapper social={social}>{socialList[social].Icon}</S.IconWrapper>
			{socialList[social].name}로 가입한 계정이에요.
		</>
	);
}
